import styled from 'styled-components';

import { OpenArrowButtonStyled } from '../../active-button';
import { Text } from '../../texts';

const ITEM_HEIGHT = 20;

export const DropDownContainer = styled.div`
  outline: none;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  width: 80px;
  height: 20px;
  border-radius: 5px;
  border: 1px solid ${(p) => p.theme.color.background};
  background-color: ${(p) =>
    p.isDropdownOpen ? p.theme.color.backgroundRush : p.theme.color.background};
  padding: 3px 0px 3px 5px;
  user-select: none;

  &:hover:not(:focus-within) {
    border: 1px solid ${(p) => p.theme.color.pale};
  }

  ${Text} {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const SelectedContent = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  border-radius: 5px;
  &:focus-within {
    background-color: ${(p) => p.theme.color.backgroundRush};
  }

  ${OpenArrowButtonStyled.Container} {
    padding-right: 10px;
    svg {
      transform: ${(p) => (p.isOpen ? 'rotate(360deg)' : 'rotate(270deg)')};
    }
  }
`;

const TextsContainer = styled.div`
  flex-grow: 1;
  overflow: hidden;

  ${Text} {
    font-size: 12px;
  }
`;

const DropDownMenuContainer = styled.div`
  position: absolute;
  display: ${p => !p.isShowNoResults ? 'block' : 'none'};
  top: 25px;
  right: 0;
  min-width: 105px;
  max-width: 240px;
  border-radius: 5px;
  height: ${(p) => p.height}px;
  z-index: 1;
  box-shadow: 0 0 0 1px ${(p) => p.theme.color.background};
  background-color: ${(p) => p.theme.color.backgroundRush};

  > div {
    border-radius: 5px;
    padding-bottom: 3px;
    > div {
      overflow: auto !important;
      &:first-child {
        position: initial !important;
        display: flex;
        flex-direction: column;
        border-radius: 5px;
        ${p => p.scrollHeight ? 'max' : 'min'}-height: 100%;
      }
      :nth-child(2) {
        display: none;
      }

      > div {
        border-radius: 5px;
        border: none;
        border-color: transparent;
        > div {
          max-width: 100%;
        }
      }
    }
  }
`;

export const DropDownItem = styled.div`
  outline: none;
  box-sizing: border-box;
  position: relative;
  height: ${ITEM_HEIGHT}px;
  background-color: ${(p) =>
    p.isActive ? p.theme.color.turquoise : p.theme.color.backgroundRush};
  border-radius: ${(p) => (p.isActive ? 5 : 0)}px;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 10px 3px 10px;

  ${Text} {
    font-size: 12px;
    color: ${(p) => p.isActive ? p.theme.color.white : p.theme.color.mainFont};
    line-height: 20px;
  }

  &:hover {
    ${Text} {
      color: ${(p) =>
        p.isActive ? p.theme.color.white : p.theme.color.turquoise};
    }
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  cursor: text;
  outline: none;
  border: none;
  background-color: ${(p) => p.theme.color.backgroundRush};
  color: ${(props) => props.theme.color.mainFont};
  font-size: 12px;
`;

const NoResults = styled.div`
  box-sizing: border-box;
  width: 100%;
  background-color: ${(p) => p.theme.color.backgroundRush};
  display: flex;
  align-items: center;
  padding-left: 5px;
  cursor: default;

  ${Text} {
    color: ${(props) => props.theme.color.gray};
    font-size: 12px;
  }
`;

export const Styled = {
  DropDownMenuContainer,
  DropDownContainer,
  SelectedContent,
  TextsContainer,
  DropDownItem,
  ITEM_HEIGHT,
  SearchInput,
  NoResults,
};
